import { createRouter, createWebHistory } from 'vue-router'
import { useEnvironmentStore } from '@/stores/environmentStore'
import { useModuleStore } from "@/stores/moduleStore";
import HomeView from '@/views/HomeView.vue'
import NewUserView from '@/views/NewUserView.vue'
import OnBoardingView from '@/views/OnBoardingView.vue'
import ProfileView from '@/views/ProfileView.vue'
import LoginView from '@/views/LoginView.vue'
import AnalyseView from '@/views/ModuleAssessmentView.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      alias: '/home',
      component: HomeView
    },
    {
      path: '/onboarding',
      name: 'onboarding',
      component: OnBoardingView
    },
    {
      path: '/login/:username?/:password?',
      name: 'login',
      props: true,
      component: LoginView
    },
    {
      path: '/new-user/:campaignCode?',
      name: 'newUser',
      props: true,
      component: NewUserView
    },
    {
      path: '/profile/',
      name: 'profile',
      component: ProfileView
    },
    {
      path: '/analyse/',
      name: 'analyse',
      component: AnalyseView
    },
    {
      path: '/summary',
      name: 'summary',
      component: () => import('../views/SummaryView.vue')
    },
    {
      path: '/new-improvement/:statementId?',
      name: 'newImprovement',
      component: () => import('../views/ImprovementView.vue')
    },
    {
      path: '/improvement',
      name: 'improvement',
      component: () => import('../views/ImprovementView.vue')
    },
    {
      path: '/worklog',
      name: 'worklog',
      component: () => import('../views/WorklogView.vue')
    },
    {
      path: '/correlation',
      name: 'correlation',
      component: () => import('../views/CorrelationView.vue')
    },
    {
      path: '/campaign/:campaignCode?',
      name: 'campaign',
      props: true,
      component: () => import('../views/CampaignView.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/ContactView.vue')
    }
  ],

  scrollBehavior() {
    document.getElementById('header')?.scrollIntoView({ behavior: 'smooth' })
  }
})

const publicNames = new Set(['login', 'newUser', 'campaign', 'onboarding'])

router.beforeEach(async (to) => {
  const env = useEnvironmentStore()
  env.hydrateFromStorage?.()

  if (publicNames.has(String(to.name))) return true

  // verify session
  const ok = await env.ensureSession().catch(() => false)
  if (!ok) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  // load protected data after session is valid
  const store = useModuleStore()
  if (!store.isLoaded) await store.fetchAll(false)

  const moduleId = typeof to.query.moduleId === 'string' ? to.query.moduleId : null
  store.ensureSelected(moduleId)

  return true
})

export default router
